import React, { useState } from 'react';

function SignAgreement() {
  return (
    <>
      <div className="space-y-2">
        <div className="mt-6">
          <h1 className="my-4 text-sm lgg:text-2xl text-black font-normal">
            Agreement Title
          </h1>
          <p className=" font-light">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </p>
          <h2 className="my-4 text-sm lgg:text-xl text-black font-normal">
            Subheader
          </h2>
          <p className=" font-light">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </p>
          <h2 className="my-4 text-sm lgg:text-xl text-black font-normal">
            Subheader
          </h2>
          <p className=" font-light">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum. voluptate
            velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
            occaecat cupidatat non proident, sunt in culpa qui officia deserunt
            mollit anim id est laborum.
          </p>
          <div className="flex w-full py-10">
            <div className="w-1/2 pr-10">
              <label>Full Name</label>
              <input
                type="text"
                className="w-full form-input bg-portal-100 border-0 font-medium text-portal-900 "
              />
            </div>
            <div className="w-1/2 pr-10">
              <label>Signature</label>
              <input
                type="text"
                className="w-full form-input bg-portal-100 border-0 font-medium text-portal-900"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SignAgreement;
